export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  {
    q: "什么是「工口游戏」？",
    a: "工口游戏（エロゲー，Eroge）是包含成人情感与亲密叙事的电子游戏类型，通常以文字冒险（视觉小说）为主，兼顾剧情、角色养成与多分支结局。它并不等于纯视觉内容，很多作品的核心价值在于剧本与人物塑造。",
  },
  {
    q: "第一次玩，应该怎么选？",
    a: "建议从「入门推荐」栏目开始，优先选择剧情温暖、系统简单、单周目体量适中的作品，比如《心之回廊》《樱花便利店物语》。等你习惯了叙事节奏，再向奇幻史诗或悬疑烧脑题材进阶。",
  },
  {
    q: "这类游戏在哪里购买与游玩？",
    a: "多数作品发布于 Steam、DLSite、DMM 或制作组的官方商城，部分作品也有官方中文版。购买前请确认你的地区与账号政策，并留意作品是否有 R18 补丁或年龄验证要求。",
  },
  {
    q: "评价里的评分是怎么来的？",
    a: "幻夜志的评分综合了编辑实机体验、社区口碑与投票，围绕剧情、美术、演出、音乐与玩法五个维度加权得出。分数会随版本更新与长线口碑调整，并非绝对标准，仅供参考。",
  },
  {
    q: "「神作」「口碑作」的标准是什么？",
    a: "「神作」指在剧情、演出或玩法上达到里程碑级水准、经得起时间检验的作品；「口碑作」指社区讨论度高、长线评价稳定的优秀作品。两者都要求绝大多数玩家愿意主动推荐。",
  },
  {
    q: "我只想轻松玩，不看沉重剧情，有推荐吗？",
    a: "可以关注「治愈日常」与「校园纯爱」分类，如《心之回廊》《夏日烟火大会》，节奏舒缓、氛围温柔，没有强行致郁的内容，适合放松时慢慢体验。",
  },
  {
    q: "不同作品适合的游玩时长差异大吗？",
    a: "差异很大。短篇治愈作单周目约 5—8 小时即可通关；长篇史诗如《星海的回响》全支线可能超过 40 小时。我们在评测正文里都会标注预估时长，方便你规划。",
  },
];